// React
import React, { Component } from "react";

// Components
import { MessageBox } from '../../Components';

// Routes
import { LoginRoutes } from '../../Routes';

// Utils
import { Validate } from '../../Utils';

/**********************************************************
 *    Login Panel Component
 * 
 *  - Validates the inputs for login/signup
 *  - Facilitates the login/signup process
 * 
 **********************************************************/

export class SignupTab extends Component {

/**********************************************************
 *  Constructor
 **********************************************************/

    constructor(props) {

        super(props);

        this.state = {
            username : '',
            password : '',
            email : '',
            betaCode : '',
            message : null
        };
    }

/**********************************************************
 *  Component Lifecycle Functions
 **********************************************************/

    // After first render
    componentDidMount() {

        //console.log('SignupTab.componentDidMount()');
    }


    // Determines whether or not the SignupTab should update
    shouldComponentUpdate(nextProps, nextState) {

        if(nextProps !== this.props || nextState !== this.state) {
            return true;
        }
        
        return false;
    }


/**********************************************************
 *  Validating Inputs
 **********************************************************/

    // If user hits enter button on page,
    // treat as if they clicked login buton
    handleKeyPress = (target) => {

        if(target.charCode===13) {
            this.signup();
        }
            
    }


    // Changes the value of username and validates on each keystroke
    updateUsername = (event) => {

        var updatedUsername = event.target.value;
        var _this = this;

        _this.setState((prevState,props) => {
            return {
                username: updatedUsername
            }
        });

    }


    // Changes the value of password on each keystroke
    updatePassword = (event) => {

        var updatedPassword = event.target.value;
            
        this.setState((prevState,props) => {
            return {
                password: updatedPassword
            }
        });
    }


    // Changes the value of email on each keystroke
    updateEmail = (event) => {

        var updatedEmail = event.target.value;
            
        this.setState((prevState,props) => {
            return {
                email: updatedEmail
            }
        });
    }

    // Changes the value of beta code
    updateBetaCode = (event) => {

        var updatedCode = event.target.value;
            
        this.setState((prevState,props) => {
            return {
                betaCode: updatedCode
            }
        });
    }

    // Validates the beta
    validateBetaCode = () => {

        return new Promise( (resolve, reject) => {

            if(this.state.betaCode == '8887')
                resolve(true);
            else
                resolve(false);

        });

    }


    // Upon a user inputting a password, validate the username
    validateUsername = (username) => {

        return new Promise( (resolve, reject) => {
        
            LoginRoutes.isUsernameTaken(username)
                .then( taken => {
                    resolve(!taken);
                })
                .catch( (error) => { 
                    reject(error);
                });
        });
        
    }


    // Verify that username and password are properly formatted
    verifyInputs = () => {

        const username = this.state.username.trim();
        const password = this.state.password; // no trim for passwords
        const email = this.state.email.trim();

        const usernameErrors = Validate.username(username);
        const passwordErrors = Validate.password(password, username);
        const emailErrors = Validate.email(email);

        return usernameErrors.concat(passwordErrors, emailErrors);
    
    }


    // Displays a message box on login panel with given parameters
    displayMessage(title, details, type) {

        const msg = {
            title : title,
            details : details,
            type : type
        };

        this.setState((prevState,props) => {
            return {
                message : msg
            }
        });

    }

/**********************************************************
 *  Signup
 **********************************************************/

    // Facilitates login request with username and password
    signup = () => {

        // TODO: encrypt password before request

        var _this = this;

        //console.log('SignupTab.signup()');

        // 1. check if username is valid
        this.validateUsername(this.state.username)
            .then( (available) => {

                // 2. verify all of the inputs
                if(available)
                    return this.verifyInputs();
                else
                    throw 'Somebody already has this username. ';
            })
            .then( (errorMessages) => {

                // 3. send signup request
                if(errorMessages.length === 0) {

                    const credentials = {
                        "username" : this.state.username.trim(),
                        "password" : this.state.password, // no trim
                        "email" : this.state.email.trim()
                    };
            
                    return LoginRoutes.signup(credentials);
                }
                else 
                    throw errorMessages.join(' ');

            })
            .then( (response) => {
             
                // redirect them to next page notifying them to click signup email
                _this.props.history.push(
                    {
                        pathname: '/success/' + this.state.username,
                        state: {loggedIn: true}
                    }
                );

            })
            .catch( (error) => {

                if(error.hasOwnProperty('beta'))
                    this.displayMessage('Beta Access', error.beta, '');
                else if(error.hasOwnProperty('message'))
                    this.displayMessage('Signup Error', error.message, 'error');
                else
                    this.displayMessage('Signup Error', error, 'error');

            });

    }

/**********************************************************
 *  Render
 **********************************************************/

  // Renders the SignupTab Component with children:
  // SignupTabSettings and Pricer
  render() {

    var errorMessageRow = null;

    if(this.state.message !== null) {
        errorMessageRow = (
            <div className="row error-row">
                <div className="col-lg-10 col-lg-offset-1 col-sm-12">
                    <MessageBox message={this.state.message} />
                </div>
            </div>
        );
    }

    return (            

            <div>

                {/*-- row --*/}
                <div className="row">
                    <div className="col-lg-10 col-lg-offset-1 col-sm-12">

                        <div className="splash-input" >
                            <input type="text" placeholder="username"
                            onChange={this.updateUsername} onKeyPress={this.handleKeyPress}
                            value={this.state.username}></input>
                            <i className="icon-user text-size-xlarge"></i>
                        </div>

                    </div>
                </div>
                {/*-- / row --*/}

                {/*-- row --*/}
                <div className="row">
                    <div className="col-lg-10 col-lg-offset-1 col-sm-12">

                        <div className="splash-input" >
                            <input type="text" placeholder="email"
                            value={this.state.email} onChange={this.updateEmail} onKeyPress={this.handleKeyPress}></input>
                            <i className="icon-envelop3 text-size-xlarge"></i>                          
                        </div>

                    </div>
                </div>
                {/*-- / row --*/}

                {/*-- row --*/}
                <div className="row">
                    <div className="col-lg-10 col-lg-offset-1 col-sm-12">
                        
                        <div className="splash-input" >
                            <input placeholder="password" type="password"
                            value={this.state.password} onChange={this.updatePassword} 
                            onKeyPress={this.handleKeyPress} ></input>
                                <i className="icon-lock text-size-xlarge"></i>
                        </div>

                    </div>
                </div>
                {/*-- / row --*/}

                { errorMessageRow }

                {/*-- row --*/}
                <div className="row">
                    <div className="col-lg-5 col-lg-offset-1 col-md-6 col-md-offset-0 col-sm-6 col-sm-offset-0 col-xs-7 col-xs-offset-0">
                        {/*<div className="splash-input" >
                            <input placeholder="code"
                            value={this.state.betaCode} onChange={this.updateBetaCode} 
                            onKeyPress={this.handleKeyPress} ></input>
                        </div>*/}
                    </div>
                    <div className="col-lg-5 col-lg-offset-0 col-md-5 col-md-offset-1 col-sm-6 col-sm-offset-0 col-xs-5">
                        <button type="button" className="btn btn-raised bg-purple-400 legitRipple pull-right splash-button"
                        onClick={this.signup} onKeyPress={this.handleKeyPress}><span>SIGNUP</span></button>
                    </div>
                </div>
                {/*-- / row --*/}

            </div>


    );
  }
};



// WEBPACK FOOTER //
// ./src/Views/Login/SignupTab.js